import { Elena, html, nothing } from "@elenajs/core";

export default class MdButton extends Elena(HTMLElement) {
  static tagName = "md-button";
  static props = [
    "variant",
    "size",
    "lefticon",
    "righticon",
    "square",
    "wibble",
    "href",
    "download",
  ];
  static events = ["click", "focus", "blur"];

  /** @property @type {"default" | "primary" | "secondary"} */
  variant = "default";
  /** @property @type {"sm" | "md" | "lg"} */
  size = "sm";
  /** @property @type {string} */
  lefticon = "";
  /** @property @type {string} */
  righticon = "";
  /** @property @type {Boolean} */
  square = false;
  /** @property @type {Boolean} */
  wibble = false;
  /** @property @type {string} */
  href = "";
  /** @property @type {Boolean} */
  download = false;

  renderButton() {
    return html`
      <button class="md-button">
        ${this.lefticon
          ? html`<i class="lefticon ${this.lefticon}"></i>`
          : nothing}
        ${this.text}
        ${this.righticon
          ? html`<i class=" righticon ${this.righticon}"></i>`
          : nothing}
      </button>
    `;
  }

  renderLink() {
    return html`
      <a
        class="md-button"
        href="${this.href}"
        ${this.download ? "download" : nothing}
      >
        ${this.lefticon
          ? html`<i class="lefticon ${this.lefticon}"></i>`
          : nothing}
        ${this.text}
        ${this.righticon
          ? html`<i class="righticon ${this.righticon}"></i>`
          : nothing}
      </a>
    `;
  }

  render() {
    return this.href ? this.renderLink() : this.renderButton();
  }
}
MdButton.define();
